export default [
    {
        path: '/notificar-siniestro/index',
        name: 'NotificarSiniestroView',
        component: () => import('../views/siniestro/NotificarSiniestroView.vue')
    },
    {
        path: '/apertura-siniestro/index',
        name: 'AperturaSiniestroView',
        component: () => import('../views/siniestro/AperturaSiniestroView.vue')
    },
    {
        path: '/liquidacion-siniestro/index',
        name: 'LiquidacionSiniestroView',
        component: () => import('../views/siniestro/LiquidacionSiniestroView.vue')
    },
    {
        path: '/informe-siniestro/index',
        name: 'InformeSiniestroView',
        component: () => import('../views/siniestro/InformeSiniestroView.vue')
    },
]